import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEAlphaBetaProdTypes, OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEDemoTargetType as OEDemoTargetType_, OEDemoStartSelectionContent} from './oe-demo-consts';

export const OEDemoTargetType = OEDemoTargetType_;

export const OEDemoTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OEDemoTargetType.anatomy]: [
            OETarget.humanForearmDemo,
        ],
        [OEDemoTargetType.histology]: [
            OETarget.humanLiverMicro
        ],        
        [OEDemoTargetType.ophthalmology]: [
            OETarget.surgeryEyeCataract
        ], 
        [OEDemoTargetType.orthopedic]: [
            OETarget.implantcastEcoFitHipStem,
            OETarget.surgeryIdo,
            OETarget.surgeryLinkEmbrace
        ],
        [OEDemoTargetType.toxicology]: [
            OETarget.humanEyeCornea
        ],
        [OEDemoTargetType.visceral]: [
            OETarget.surgeryAppendix
        ],
        // [OEDemoTargetType.cell]: [
        //     OETarget.humanBrainPotential
        // ]
    },
    {
        [OEDemoTargetType.orthopedic]: {
            [OEAlphaBetaProdTypes.def]: OETarget.implantcastEcoFitHipStem,
            [OEAlphaBetaProdTypes.beta]: OETarget.implantcastEcoFitHipStem,
            [OEAlphaBetaProdTypes.prod]: OETarget.implantcastEcoFitHipStem,
        }
    }
);

export const OEDemoFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
            histologyTargetSelection: !isLicensing,
            ophthalmologyTargetSelection: !isLicensing,
            orthopedicTargetSelection: !isLicensing,
            toxicologyTargetSelection: !isLicensing,
            visceralTargetSelection: !isLicensing,
            // cellTargetSelection: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.anatomyTargetSelection = true;
                featureAccess.histologyTargetSelection = true;
                featureAccess.ophthalmologyTargetSelection = true;
                featureAccess.orthopedicTargetSelection = true;
                featureAccess.toxicologyTargetSelection = true;
                featureAccess.visceralTargetSelection = true;
                // featureAccess.cellTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEDemoTargets);

export const OEDemoStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEDemoTargets,
    OEDemoStartSelectionContent
);